<template  >
  <div class="col-xs-12 menu-container" style="">
   <ag-grid-vue :style="getStyle"  class="ag-bootstrap" :gridOptions="gridOptions" :rowData="rowData"></ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { bus } from "@/libs/bus";
import debug from "debug";
var debug_multiselect = debug("esma:multi-select");

export default {
  data() {
    return {
      gridOptions: [],
      row_data: [],
      data_style: ""
    };
  },
  components: {
    "ag-grid-vue": AgGridVue
  },
  computed: {
    getStyle() {
      return this.data_style;
    },
    rowData() {
      return this.row_data;
    }
  },
  props: {
    options: { default: [] },
    msstyle: { default: "" },
    busname: { default: false }
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
    this.gridOptions.api.forEachNode(node => {
      debug_multiselect("Checking", node.data);
      if (
        typeof node != "undefined" &&
        typeof node.data != "undefined" &&
        node.data.selected == true
      ) {
        this.gridOptions.api.selectNode(node, true);
      }
    });
  },
  beforeMount() {
    debug_multiselect("beforeMount")
    if (this.$props.busname != false) {
      debug_multiselect("beforeMount", "listen for", this.$props.busname)
      bus.$on(this.$props.busname, data => {
        debug_multiselect("On new data for ",this.$props.busname)
        this.row_data = data;
      });
    }

    this.row_data = this.$props.options;
    this.data_style =
      "min-width:100px;width: 100%; height: 120px;border: 1px solid #ccc;" +
      this.$props.msstyle;
    this.gridOptions = {
      defaultColDef: {
        editable: false
      },
      getRowNodeId: function(data) {
        return data.value;
      },
      enableSorting: false,
      enableColResize: false,
      suppressMovableColumns: false,
      rowSelection: "single",
      suppressHorizontalScroll: true,
      overlayNoRowsTemplate :"<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      headerHeight: 0,

      onRowSelected: ev => {
        if (ev.node.isSelected()) {
          debug_multiselect("ev.node",ev.node)
          this.$emit("onSelected", {
            selected: ev.node.data.value,
            data: ev.node.data
          });
          debug_multiselect(ev.node.data.value);
        }
      }
    };

    this.gridOptions.columnDefs = [
      {
        headerName: "Value",
        field: "value",
        hide: true
      },
      {
        headerName: "",
        field: "name",
        hide: false
        // sort: 'asc'
      }
    ];
  }
};
</script>
<style scoped>
.menu-container {
  padding: 5px 5px 15px 5px;
}
</style>



// WEBPACK FOOTER //
// multi-select.vue?7e7872b6